// need a variable to prefix all static paths depending on the environment
// vite serves from /static, but the frontend is served from /static/frontend in django
// if vite mode is production, the frontend is served from /static/frontend, else empty string
export const staticPath = import.meta.env.PROD ? '/static/frontend' : ''

export const amplifyConfig = {
    aws_project_region: import.meta.env.VITE_AWS_PROJECT_REGION,
    aws_cognito_identity_pool_id: import.meta.env
        .VITE_AWS_COGNITO_IDENTITY_POOL_ID,
    aws_cognito_region: import.meta.env.VITE_AWS_COGNITO_REGION,
    aws_user_pools_id: import.meta.env.VITE_AWS_USER_POOLS_ID,
    aws_user_pools_web_client_id: import.meta.env
        .VITE_AWS_USER_POOLS_WEB_CLIENT_ID
}

export const auth0Config = {
    client_id: import.meta.env.VITE_AUTH0_CLIENT_ID,
    domain: import.meta.env.VITE_AUTH0_DOMAIN
}

export const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET
}

export const gtmConfig = {
    containerId: import.meta.env.VITE_GTM_CONTAINER_ID
}

/**
 * XMPP / ejabberd chat configuration.
 *
 * Set these in your .env file:
 *
 *   VITE_XMPP_WS_URL       WebSocket endpoint, e.g. wss://chat.example.com/websocket
 *   VITE_XMPP_SERVICE      XMPP server domain, e.g. example.com
 *   VITE_XMPP_MUC_SERVICE  MUC conference domain, e.g. conference.example.com
 */
export const xmppConfig = {
    wsUrl: import.meta.env.VITE_XMPP_WS_URL ?? '',
    service: import.meta.env.VITE_XMPP_SERVICE ?? '',
    mucService: import.meta.env.VITE_XMPP_MUC_SERVICE ?? ''
}
